export default __webpack_public_path__ + "static/treatmentareas-ButtAfter-46986ee14e8e5a11e8104f53eaa39ffd.webp";